module.exports = __webpack_public_path__ + "static/img/u=3209370120,2008812818&fm=26&gp=0.4086294f.jpg";